import React from 'react';
import styled from 'styled-components';
import { EXTERNAL_LINKS } from '../../../utils/constants';

const FooterContainer = styled.footer`
  background-color: ${({ theme }) => theme.colors.primary};
  color: ${({ theme }) => theme.colors.white};
  padding: ${({ theme }) => theme.spacing.lg} 0;
  margin-top: ${({ theme }) => theme.spacing.xxl};
`;

const FooterContent = styled.div`
  max-width: ${({ theme }) => theme.breakpoints.wide};
  margin: 0 auto;
  padding: 0 ${({ theme }) => theme.spacing.sm};
  text-align: center;
`;

const FooterLink = styled.a`
  color: ${({ theme }) => theme.colors.white};
  text-decoration: none;
  
  &:hover {
    text-decoration: underline;
  }
  
  &:focus {
    outline: 2px solid ${({ theme }) => theme.colors.white};
    outline-offset: 2px;
  }
`;

const FooterText = styled.p`
  margin: 0;
  font-size: 0.9rem;
  opacity: 0.9;
`;

export const Footer: React.FC = () => {
  return (
    <FooterContainer role="contentinfo">
      <FooterContent>
        <FooterText>
          <FooterLink 
            href={EXTERNAL_LINKS.DIABETES_LIVE} 
            target="_blank" 
            rel="nofollow noopener noreferrer"
          >
            Diabetes Live, New Zealand
          </FooterLink>
        </FooterText>
      </FooterContent>
    </FooterContainer>
  );
};

export default Footer;
